import { useMediaQuery, useTheme } from "@mui/material";
import { MOBILE_BREAKPOINT } from "../styles/responsive";

/** SP 表示か（MOBILE_BREAKPOINT 未満）。レスポンシブ判定はこの hook に統一する。 */
export const useIsMobile = (): boolean => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down(MOBILE_BREAKPOINT));
};
